import { Button, HStack, Stack, useDisclosure } from "@chakra-ui/react";
import {
  faDollar,
  faTags,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { partiuClient } from "../../axios";
import { CompanyContext } from "../../contexts/CompanyContext";
import { StatisticCard } from "../molecules/StatisticCard";
import { ReferrerModal } from "./ReferrerModal";

export function StoreStatistics() {
  const { store } = useContext(CompanyContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: sales = [], isLoading } = useQuery({
    queryKey: ["sales"],
    queryFn: () => partiuClient.salesApp.sales.listStoreSales(store.id)
  });

  const value = sales.map
    ? sales
        .map((s) => s.pdv_given_total || s.saved || 0)
        .reduce((p = 0, c) => p + c, 0)
    : 0;

  return (
    <Stack
      justify="flex-end"
      width="100%"
      direction={{ base: "column", md: "row" }}
      spacing={3}
    >
      <StatisticCard
        icon={faDollar}
        title="Vendas (este mês)"
        loading={isLoading}
        description={sales.length}
      />
      <StatisticCard
        icon={faDollar}
        title="Receita Vendas (este mês)"
        loading={isLoading}
        description={value}
        formatOptions={{
          style: "currency",
          currency: "BRL",
        }}
      />
      <StatisticCard
        icon={faTags}
        title="Desconto(s) Cadastrados"
        description={store.discounts.length}
      />
      <StatisticCard
        icon={faUserPlus}
        title="Indique amigos e ganhe benefícios exclusivos!"
        description="-"
        onClick={onOpen}
        bigNum={false}
      />
      <ReferrerModal isOpen={isOpen} onClose={onClose} />
    </Stack>
  );
}
